import { render } from "./ServisView.vue?vue&type=template&id=6fd1594a&scoped=true"
import script from "./ServisView.vue?vue&type=script&lang=js"
export * from "./ServisView.vue?vue&type=script&lang=js"

import "./ServisView.vue?vue&type=style&index=0&id=6fd1594a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Дентакорплюс\\dentakor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fd1594a"]])

export default __exports__